"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "@/i18n/navigation";
import { inBeta } from "@/lib/api/prefix.common";
import { ReactNode } from "react";
import { ApiConfigContext } from "./ApiConfigContext";
export default function DefaultApiConfigProvider(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = inBeta(pathname);
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      beta: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const config = t2;
  let t3;
  if ($[4] !== children || $[5] !== config) {
    t3 = <ApiConfigContext value={config}>{children}</ApiConfigContext>;
    $[4] = children;
    $[5] = config;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}